import {
  Identify,
  Revenue,
  add,
  flush,
  getDeviceId,
  getSessionId,
  getUserId,
  identify,
  init,
  revenue,
  setDeviceId,
  setOptOut,
  setSessionId,
  setUserId,
  track,
} from '@amplitude/analytics-browser';

export const addAmplitudePlugin = add;
export const flushAmplitudeEvents = flush;
export const getAmplitudeDeviceId = getDeviceId;
export const getAmplitudeSessionId = getSessionId;
export const getAmplitudeUserId = getUserId;
export const initializeAmplitudeSdk = init;
export const setAmplitudeDeviceId = setDeviceId;
export const setAmplitudeOptOut = setOptOut;
export const setAmplitudeSessionId = setSessionId;
export const setAmplitudeUserId = setUserId;

export const trackAmplitudeEvent = (eventName: string, attributes: Record<string, any>): void => {
  track(eventName, attributes);
};

export const recordAmplitudeRevenue = (
  amount: number,
  eventProperties: Record<string, any>
): void => {
  const revenueEvent = new Revenue();
  revenueEvent.setRevenue(amount).setEventProperties(eventProperties);
  revenue(revenueEvent);
};

export const recordAmplitudeUserProperties = (
  userProperties: object,
  unsetValue: unknown
): Promise<unknown> => {
  const identifyEvent = new Identify();
  for (const [key, value] of Object.entries(userProperties)) {
    if (value === unsetValue) {
      identifyEvent.unset(key);
    } else {
      identifyEvent.set(key, value as any);
    }
  }

  return identify(identifyEvent).promise;
};
